class OverviewModel {
  constructor() {
    this.balance = {
      unallocated: null,
      available: null,
      acWalletWithdrawable: 0,
      totalRunningCommission: 0,
    };
    this.currency = null;
    this.balanceSummary = null;
    this.balancePerProduct = null;
    this.transactionTable = {
      transactions: null,
      pagination: null
    };
    this.customerProducts = null;
  }
}

export default OverviewModel;



// WEBPACK FOOTER //
// ./client/app/pages/customer/overview/model/overview.model.js